function SetSummaryDetailsDataHelper(
    agingDetailsServerGridRef,
    useStateUpdateCall) {

    if (agingDetailsServerGridRef.current) {
        let retrievedServerGridData = agingDetailsServerGridRef.current.GetAllGridData();

        if (retrievedServerGridData) {
            let summaryDataRow = {
                ClaimCount: retrievedServerGridData.total ? retrievedServerGridData.total : 0,
                Adjudicated:
                    retrievedServerGridData.fieldTotals && retrievedServerGridData.fieldTotals.promisetopay
                        ? retrievedServerGridData.fieldTotals.promisetopay
                        : 0,
                Paid:
                    retrievedServerGridData.fieldTotals &&
                        retrievedServerGridData.fieldTotals.remittancepaid
                        ? retrievedServerGridData.fieldTotals.remittancepaid
                        : 0,
                Outstanding:
                    retrievedServerGridData.fieldTotals && retrievedServerGridData.fieldTotals.outstanding
                        ? retrievedServerGridData.fieldTotals.outstanding
                        : 0
            };

            let output = [];
            output.push(summaryDataRow);

            useStateUpdateCall(output);
        }
    }
}

export { SetSummaryDetailsDataHelper };